import React from 'react';
interface SiteFooterProps {
  /** Route of the page rendering the footer, so its own link can be marked current. */
  currentPath?: string;
}
const links = [{
  href: '/get-the-app',
  label: 'Download the App'
}, {
  href: '/practitioners',
  label: 'Practitioners'
}, {
  href: '/investors',
  label: 'Investors'
}, {
  href: '/privacy-policy',
  label: 'Privacy Policy'
}, {
  href: '/terms-of-service',
  label: 'Terms of Service'
}, {
  href: '/terms-of-sale',
  label: 'Terms of Sale'
}];
export function SiteFooter({
  currentPath
}: SiteFooterProps) {
  return <footer className="bg-charcoal text-ivory/50 border-t border-white/10" data-id="element-712" data-mp="3p1mjz4spel3o">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-sm" data-id="element-713" data-mp="3u0pcjprhyyur">
        <p data-id="element-714" data-mp="lke5mux6q3dp">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
        <nav aria-label="Footer" data-id="element-715" data-mp="qd797fgx35o7">
          <ul className="flex flex-wrap items-center gap-x-8 gap-y-3" data-id="element-716" data-mp="qeicle6gabes">
            {links.map(link => {
            const isCurrent = link.href === currentPath;
            return <li key={link.href} data-id="element-717" data-mp="1fwtwtexmpycg">
                  <a href={link.href} aria-current={isCurrent ? 'page' : undefined} className={`transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded ${isCurrent ? 'text-ivory' : 'hover:text-ivory'}`} data-id="element-718" data-mp="1tq1sbhotzdzf">
                    {link.label}
                  </a>
                </li>;
          })}
          </ul>
        </nav>
      </div>
    </footer>;
}